import React, { useState } from "react";
import { HiArrowRight } from "react-icons/hi";
import contact from "../../Images/new/contact.png";
import API from "../../utils/api";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
    company: "", // honeypot (keep it hidden)
  });

  const [status, setStatus] = useState({
    loading: false,
    ok: null, // true/false/null
    msg: "",
  });

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    // simple validation
    if (!form.name.trim() || !form.email.trim()) {
      setStatus({ loading: false, ok: false, msg: "Bitte Name und E-Mail eingeben." });
      return;
    }

    // if bot filled honeypot, silently succeed
    if (form.company) {
      setStatus({ loading: false, ok: true, msg: "Danke! Wir melden uns bald." });
      return;
    }

    try {
      setStatus({ loading: true, ok: null, msg: "" });

      // IMPORTANT: make sure your backend expects these fields
      await API.post("/contact", {
        name: form.name,
        email: form.email,
        message: form.message || "(no message)",
        formName: "Contact Section",
      });

      setStatus({ loading: false, ok: true, msg: "Danke! Wir melden uns innerhalb von 24 Stunden." });
      setForm({ name: "", email: "", message: "", company: "" });
    } catch (err) {
      console.error(err);
      setStatus({
        loading: false,
        ok: false,
        msg: "Leider ist etwas schiefgelaufen. Bitte später erneut versuchen.",
      });
    }
  };

  return (
    <div className="w-full bg-[#0b2b40] px-0 md:px-0 py-4 md:py-16 md:pb-12 flex flex-col justify-center mx-auto items-center">
      <div className="w-[90%] 2xl:w-[70%] pb-8 flex flex-col lg:flex-row items-center gap-10 bg-gradient-to-r from-[#1F2937] via-[#374151] to-[#1F2937] p-8 pb-0 rounded-2xl">
        {/* Left Content */}
        <div className="flex flex-col w-full lg:w-1/2 gap-6 text-white">
          <h2 className="!text-white h2-mb h2-md h2-lg h2-2xl">
            Sie haben Fragen? Wir unterstützen Sie gerne.
          </h2>
          <p className="text-white/70 text-sm md:text-lg leading-relaxed">
            Mit unserer umfassenden Erfahrung im Reputationsmanagement kennen wir die Herausforderungen Ihrer Branche genau
            und entwickeln Strategien, die Ihren Online-Ruf nachhaltig stärken. Nutzen Sie unsere Expertise.
          </p>

          <div className="flex items-center gap-3">
            <svg width="32" height="33" viewBox="0 0 32 33" fill="none">
              <circle cx="16" cy="16.5" r="8" fill="#07EF83"></circle>
              <circle cx="16" cy="16.5" r="12" stroke="#60FFB5" strokeOpacity="0.2" strokeWidth="8"></circle>
            </svg>
            <span className="text-sm md:text-lg">wir melden uns innerhalb von 24 Stunden bei Ihnen.</span>
          </div>

          {/* Form */}
          <form onSubmit={onSubmit} className="flex flex-col gap-4 mt-4">
            <div className="flex flex-col sm:flex-row gap-3 w-full">
              <input
                className="w-full rounded-lg bg-[#0b2b40] placeholder-white px-4 py-3 outline-none"
                placeholder="Ihr Name"
                type="text"
                name="name"
                value={form.name}
                onChange={onChange}
                autoComplete="name"
              />
              <input
                className="w-full rounded-lg bg-[#0b2b40] placeholder-white px-4 py-3 outline-none"
                placeholder="Ihre E-Mailadresse"
                type="email"
                name="email"
                value={form.email}
                onChange={onChange}
                autoComplete="email"
              />
            </div>

            {/* OPTIONAL message field (recommended) */}
            <textarea
              className="w-full rounded-lg bg-[#0b2b40] placeholder-white px-4 py-3 outline-none min-h-[120px]"
              placeholder="Ihre Nachricht (optional)"
              name="message"
              value={form.message}
              onChange={onChange}
            />

            {/* Honeypot (hidden) */}
            <input
              type="text"
              name="company"
              value={form.company}
              onChange={onChange}
              tabIndex={-1}
              autoComplete="off"
              className="hidden"
            />

            <button
              type="submit"
              disabled={status.loading}
              className="w-full py-3 bg-white hover:opacity-90 disabled:opacity-60 text-gray-900 font-semibold rounded-full transition flex gap-8 items-center justify-between px-4"
            >
              <span>{status.loading ? "Senden..." : "Absenden"}</span>
              <span className="bg-[#0b2b40] text-white p-1 rounded-full flex items-center justify-center">
                <HiArrowRight className="text-lg transform -rotate-24" />
              </span>
            </button>

            {/* status message */}
            {status.ok === true && (
              <p className="text-emerald-300 text-sm">{status.msg}</p>
            )}
            {status.ok === false && (
              <p className="text-red-300 text-sm">{status.msg}</p>
            )}
          </form>
        </div>

        {/* Right Image */}
        <div className="flex justify-center lg:w-1/2">
          <img
            src={contact}
            alt="advisor"
            className="w-[350px] md:w-[450px] lg:w-[520px] h-auto object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;
